/*
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-09-21 14:18:53
 * @LastEditors: loong
 * @LastEditTime: 2022-10-21 11:34:52
 */
export default {
  // 公共提示
  successCom: "操作成功！",
  errorCom: "操作失败！",
  cancelCom: "操作取消！",
  saveSuccessCom: "保存成功！",
  saveErrorCom: "保存失败！",
  editSuccessCom: "编辑成功！",
  editErrorCom: "编辑失败！",
  paySuccess: '支付成功！',
  payError: '支付失败！',
  multipleTip: '至少选择一条记录！',
  payNot: '当前订单还未完成支付，是否继续？',


  // 验证码
  smsSuccess: "验证码发送成功，请注意查收！",
  // 注册
  registerSuccess: "注册成功，请登录！",
  // 登录
  loginTips: "用户账号或密码不能为空！",
  loginForPhoneTips: '手机号或验证码不能为空！',
  loginSuccess: "登录成功！",
  toMerchantWarn: '当前账号为个人账号，请先升级企业账号',
  // 注册协议
  agreementTip: '请阅读注册协议！',

  // 获取信息提示
  getInfoFail: '获取信息失败，请稍后重试',
  // 接口调用失败
  InterfaceFail: '服务异常，请稍后再试',

  // 上传图片
  upLoadFileSuccess: '文件上传成功！',
  upLoadFileError: '文件上传失败，请稍后重试！',
  upLoadFileFormat: '上传图片只能是 JPG、png、GIF、JPEG、BMP、webp 格式！',
  upLoadFileSize: '上传图片大小不能超过 1MB！',

  // 购物车
  carDeleteShop: '是否在购物车中删除此商品?',
  deleteShopWarning: '至少选择一个商品！',
  joinBuyCarSuccess: '成功加入购物车',
  joinBuyCarFail: '加入购物车失败，请稍后再试',
}